<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" ref="field"
             :label="label">
        <vue-code-diff :old-string="oldValue" :new-string="newValue" :context="4" output-format="side-by-side" />
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import vueCodeDiff from 'vue-code-diff'

    export default {
        name: 'VDiff',
        components: {vueCodeDiff},
        mixins,

        computed: {
            parts() {
                return this.inputValue.split("-=#OLDNEWDIFFSEPARATOR#=-")
            },
            oldValue() {
                return this.parts[0]
            },
            newValue() {
                return this.parts[1]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/form/VDiff.vue